export const ROUTE_PATH = {
  ROOT: `${process.env.PUBLIC_URL}/`,
  HOME: `${process.env.PUBLIC_URL}/`,
  DETAIL: `${process.env.PUBLIC_URL}/character/:id`,
} as const;
